const DEFAULT_DURATION = 1000;
const DEFAULT_EASE_DURATION = 150;

export interface AnimateOptions {
    duration?: number;
    step: (arg: number) => void;
    ease?: (arg: number) => number;
}

export function easeLinear(t: number): number {
    return t;
}

export function easeOutQuad(t: number): number {
    return t * (2 - t);
}

export function easeInOutCubic(t: number): number {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function animate({
    duration = DEFAULT_DURATION,
    ease = easeLinear,
    step,
}: AnimateOptions): Promise<FrameRequestCallback> {
    return new Promise(resolve => {
        const start = Date.now();

        const frame = () => {
            const time = Date.now();
            let timeFraction = duration === 0 ? 1 : (time - start) / duration;

            // normalize
            if (timeFraction > 1) {
                timeFraction = 1;
            }

            const progress = ease(timeFraction);

            step(progress);

            if (timeFraction < 1) {
                requestAnimationFrame(frame);
            } else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- автоматический игнор в рамках DIRECT-265451. Исправьте при следующем редактировании при помощи type-assert, чтобы избежать возможных ложно-положительных проверок typecheck!
                // @ts-expect-error TODO DIRECT-222878 Добавить причину
                requestAnimationFrame(resolve);
            }
        };

        requestAnimationFrame(frame);
    });
}

export function animateEaseOutQuadFast({
    duration = DEFAULT_EASE_DURATION,
    ...options
}: AnimateOptions): Promise<FrameRequestCallback> {
    return animate({
        duration,
        ease: easeOutQuad,
        ...options,
    });
}
